import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class MediaIcon extends PureComponent {
    render() {
        const {
            children,
            icon,
            ...props
        } = this.props;

        return (
            <div class="media-horizontal media mt-0">
                <div>
                    <i class={"mr-1 mt-0_25 o-33 far fa-" + icon} />
                </div>
                <div class="media-body">
                    {children}
                </div>
            </div>
        );
    }
}

MediaIcon.defaultProps = {
    icon: 'person'
};

export default MediaIcon;
